import React from "react";

const CompetitionInfo = ({ competition, t }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString(undefined, {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div className="competition-info-overlay">
      <h1 className="competition-name">{competition.name}</h1>
      <div className="competition-details">
        <div className="detail-item">
          <i className="fa-solid fa-location-dot"></i>
          <span>{competition.city}</span>
        </div>
        <div className="detail-item">
          <i className="fa-solid fa-calendar"></i>
          <span>
            {formatDate(competition.started_at)} - {formatDate(competition.ended_at)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default CompetitionInfo;
